import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLevelPipe } from './pipes/translate-level.pipe';
import { TranslateRolesPipe } from './pipes/translate-roles.pipe';
import { SharedUtilModule } from '@evasys/shared/util';

@NgModule({
	imports: [CommonModule, SharedUtilModule],
	declarations: [TranslateLevelPipe, TranslateRolesPipe],
	exports: [TranslateLevelPipe, TranslateRolesPipe],
})
export class EvasysSharedUtilModule {}
